export default __webpack_public_path__ + "static/media/home__why1.1818f98e.jpg";